// BODY SECTION ALT
import React from 'react'
import SubHeader from './SubHeader'
import ToggleAlt from './ToggleAlt'
import IconHeader from './IconHeader'

export default function BodySectionAlt(props) {
    
    return(
        
        <div class="row">
        
            {props.data.map(( content_group ) => 
                        
                <div class="container containerWidth">
                    
                    <IconHeader styles="leftHeader clickableHeader iconHeader inline" iconStyle="inline size" img={content_group.icon} title={content_group.section_name}/>
                        
                    <p class="standardText">{content_group.preview_text}</p>
                                
                    <div dangerouslySetInnerHTML={{ __html: content_group.external_link }} />
                                                 
                </div>
                                             
            )}
    
        </div>
    
    )
    
}